module.exports = __webpack_public_path__ + "static/icons/icon-ski-lessons-dee3b82243f3d8cff75277cbbb46ff2f.svg";